import { z } from "zod";

// loose so params owned by other consumers of the same url (e.g. the deposit
// modal) survive a rebuild of the query string
const withdrawModalParams = z.looseObject({
  withdrawalModal: z.coerce.boolean().optional(),
});

type WithdrawModalParams = z.infer<typeof withdrawModalParams>;

export { withdrawModalParams, type WithdrawModalParams };
